export const getVolumesData = state => state?.volumes?.data || null
export const getSelectedVolume = state => state?.volumes || null
export const getVolumesDataById = state => state?.volumes?.volume || null
export const getIssueDataById = state => state?.volumes?.issue || null
export const getArticleDataById = state => state?.volumes?.article || null
export const getAllArticlesData = state => state?.volumes?.data?.articles || null
export const getArticleReferenceDataById = state => state?.volumes?.articleReference || null
